// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination li{\r\n  line-height: 30px;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  ul.pagination.browser-default {\r\n    padding-left: 0;\r\n  }\r\n}", ""]);
// Exports
module.exports = exports;
